import { amazonBucket } from 'constants/'
import { stripHtml } from 'helpers'
import { Helmet } from 'react-helmet'

export default ({ firstName, lastName, avatar, description }) => {
  const authorName = `${firstName} ${lastName}`
  const image = `${amazonBucket.bucketBaseUrl}${avatar}`
  const formattedDescription = stripHtml(description).replace(/"/g, '\\"')
  return (
    <Helmet>
      <script type='application/ld+json'>
        {
          `
            {
                "@context": "https://schema.org",
                "@type": "Person",
                "name": "${authorName}",
                "description": "${formattedDescription}",
                "affiliation": [
                    {
                        "@type": "Organization",
                        "name": "Alphorm", 
                        "url": "https://www.alphorm.com", 
                        "logo": [
                            {
                                "@type": "ImageObject",
                                "url": "https://static.alphorm.com/logos/logosanslecture.png" 
                            }
                        ]
                    }
                ],
                "image": [
                    {
                        "@type": "ImageObject",
                        "contentUrl": "${image}"
                    }
                ]
            }
          `
        }
      </script>
    </Helmet>
  )
}
